import PropTypes from 'prop-types';
import React from 'react';
import Video from '../Video';

const VideoAttachment = ({ inlineVideo: inline, ...props }) => (
  <Video width="100%" inline={inline} {...props} />
);

// TODO: play video in modal if inlineVideo

VideoAttachment.propTypes = {
  inlineVideo: PropTypes.bool,
};

VideoAttachment.defaultProps = {
  inlineVideo: true,
};

export default VideoAttachment;
